import { ambienteUrl } from 'ambiente';
import { FetchPedidosApi } from './fetch-pedidos-api';
import { MergeDeep } from 'utils';

const FetchPedidosApiWithUser = async (
  path: RequestInfo,
  options?: any,
  empresaId?: string,
): Promise<Response> => {

  const Default: RequestInit = {
    headers: {
      'Content-Type': 'application/json',
      'Domain': ambienteUrl === 'prod' ? 'menuvip.com.br' : 'staging.menuvip.com.br',
    },
  };

  const newOptions = MergeDeep(Default, options);
  return FetchPedidosApi(path, newOptions);
};

export const FetchPedidosApiWithUserJSON = async (
  path: RequestInfo,
  options?: any,
  empresaId?: string,
) => {
  let t = await FetchPedidosApiWithUser(path, options, empresaId).then(
    async (response) => {
      return await response.json()
    }
  );
  return t;
};
